export default __webpack_public_path__ + "static/media/device_led_on.922754df.svg";